import { useExportContactStatusSubscription } from '@/types/generated/graphql';
import { notification } from 'antd';
import { downloadBlobFile } from '@/shared/utils/download-blob-file';
import { useTranslation } from 'react-i18next';

export function useExportContactsSubscription() {
  const { t } = useTranslation();
  useExportContactStatusSubscription({
    onData: ({ data }) => {
      const exportData = data.data?.exportContactStatus?.data;
      if (exportData?.url) {
        downloadBlobFile(fetch(exportData?.url), {
          fileName: exportData?.originalname || 'contacts.csv',
        });
        notification.success({
          message: t('export_complete'),
          description: t('export_complete_file_ready_for_download'),
        });
      }
    },
  });
}
